export const isSafeRedirect = (value?: string): value is string => {
  if (!value) return false;

  return !/^[a-z][a-z0-9+.-]*:/i.test(value);
};